export default __webpack_public_path__ + "static/media/ADA.5dae5f73.png";